import React from 'react';
import Select from './Select';

const BrandSelect = ({
                       options = [],
                       value = null,
                       onChange = () => {},
                       isLoading = false,
                     }) => {
  return (
    <Select
      placeholder="salesFilters.Brand"
      options={options}
      value={value}
      onChange={onChange}
      isLoading={isLoading}
      isSearchable
    />
  );
};

export default BrandSelect;